import { render } from "./HomeService.vue?vue&type=template&id=f22de1aa&scoped=true"
import script from "./HomeService.vue?vue&type=script&lang=js"
export * from "./HomeService.vue?vue&type=script&lang=js"

import "./HomeService.vue?vue&type=style&index=0&id=f22de1aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22de1aa"]])

export default __exports__